import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import appStoreIcon from '../assets/appIcon.png';
import appicon from '../assets/appIcon.png';
import token from '../assets/dollar.png';
// Основной контейнер
const PromptContainer = styled(motion.div)`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  // background-color: transparent;
  z-index: 5;
`;

// Улучшенная иконка приложения с красивым выделением и анимацией
const AppIcon = styled(motion.div)`
  width: 65px;
  height: 65px;
  border-radius: 15px;
  margin: 0 auto 20px;
  position: relative;
  border-radius: 15px;
  box-shadow: 
    0 8px 20px rgba(104, 50, 220, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.15) inset;
  z-index: 1;
  
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 12px;
    background-image: url(${appStoreIcon});
    background-size: cover;
    background-position: center;
    z-index: 2;
  }
  
  &::after {
    content: '';
    position: absolute;
    inset: -5px;
    background: linear-gradient(
      125deg, 
      rgba(104, 50, 220, 0) 0%,
      rgba(104, 50, 220, 0.3) 50%, 
      rgba(104, 50, 220, 0) 100%
    );
    z-index: 1;
    animation: shine 4s infinite;
    opacity: 0.8;
  }
  
  @keyframes shine {
    0% {
      transform: rotate(0deg) translate(-15px, -15px);
    }
    25% {
      transform: rotate(90deg) translate(-15px, -15px);
    }
    50% {
      transform: rotate(180deg) translate(-15px, -15px);
    }
    75% {
      transform: rotate(270deg) translate(-15px, -15px);
    }
    100% {
      transform: rotate(360deg) translate(-15px, -15px);
    }
  }
`;

// Добавляем контейнер для верхней части карточки с гибкой разметкой
const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 30px;
`;

// Контейнер для текстового блока (заголовок + подзаголовок)
const TitleBlock = styled.div`
  flex: 1;
  text-align: left;
  padding-right: 15px;
`;

// Обновляем стиль заголовка для выравнивания по левому краю
const MainTitle = styled.h2`
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: white;
  margin: 0 0 10px;
  letter-spacing: -0.02em;
  line-height: 1.1;
  text-align: left;
  
  @media (max-width: 768px) {
    font-size: 26px;
  }
`;

// Обновляем стиль подзаголовка для выравнивания по левому краю
const Subtitle = styled.p`
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif;
  font-size: 17px;
  line-height: 1.4;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
  text-align: left;
  
  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

// Улучшенный контейнер для иконки приложения с позиционированием справа
const AppIconContainer = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
  z-index: 3;
  flex-shrink: 0;
  
  /* Эффект свечения вокруг иконки */
  &::after {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    background: radial-gradient(circle, rgba(104, 50, 220, 0.2) 0%, rgba(104, 50, 220, 0) 70%);
    border-radius: 28px;
    z-index: -1;
  }
  
  @media (max-width: 480px) {
    width: 65px;
    height: 65px;
  }
`;

// Стилизованная иконка приложения
const AppIconImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 18px;
  box-shadow: 
    0 8px 20px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.1) inset;
  object-fit: cover;
  display: block;
  
  &:hover {
    transform: scale(1.05);
    transition: transform 0.2s ease;
  }
`;

// Стеклянная карточка в стиле Apple
const GlassCard = styled.div`
  background: rgba(25, 25, 30, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 24px;
  width: 100%;
  max-width: 520px;
  padding: 40px 25px;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 255, 255, 0.08) inset,
    0 0 60px rgba(104, 50, 220, 0.15);
  text-align: left;
  position: relative;
  overflow: hidden;
  
  /* Градиентная рамка слева */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 15%;
    height: 70%;
    width: 4px;
    background: linear-gradient(
      to bottom,
      #6832DC 0%,
      #4C6FFF 100%
    );
    border-radius: 4px;
  }
  
  @media (max-width: 768px) {
    max-width: 90%;
    padding: 30px 20px;
  }
`;

// Сияющий фон
const GlowBackground = styled.div`
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(
    circle at center,
    rgba(104, 50, 220, 0.15) 0%,
    transparent 70%
  );
  z-index: -1;
  transform: rotate(-15deg);
`;

// Элемент с преимуществом
const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 22px;
  position: relative;
`;

// Иконка для преимущества
const BenefitIcon = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  flex-shrink: 0;
  
  img {
    width: 32px;
    height: 32px;
  }
`;

// Блок с текстом преимущества
const BenefitText = styled.div`
  flex: 1;
`;

// Заголовок преимущества
const BenefitTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  color: white;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  
  span {
    font-size: 20px;
    font-weight: 700;
    color: #FFD700;
    margin: 0 6px;
  }
`;

// Описание преимущества
const BenefitDescription = styled.div`
  font-size: 15px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.4;
`;

// Кнопка App Store
const DownloadButton = styled.a`
  background: linear-gradient(135deg, #0A84FF 0%, #0057DA 100%);
  color: white;
  padding: 16px;
  width: 100%;
  border-radius: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", sans-serif;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.01em;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 30px 0 0;
  box-shadow: 0 8px 20px rgba(10, 132, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  text-decoration: none;
  text-align: center;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 25px rgba(10, 132, 255, 0.4);
  }
  
  &:active {
    transform: scale(0.97);
  }
  
  @media (max-width: 768px) {
    padding: 14px;
    font-size: 16px;
  }
`;

// Иконка App Store для кнопки
const AppleIcon = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3E%3Cpath d='M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z'/%3E%3C/svg%3E");
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  }
`;

// Плавающие элементы
const FloatingElement = styled.div`
  position: absolute;
  border-radius: ${props => props.shape === 'circle' ? '50%' : '16px'};
  background: ${props => props.color};
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  opacity: ${props => props.opacity};
  filter: blur(${props => props.blur}px);
  z-index: -1;
`;

// Компонент DownloadPrompt
const DownloadPrompt = () => {
  // Данные для плавающих элементов
  const floatingElements = [
    { shape: 'circle', size: 140, color: 'rgba(104, 50, 220, 0.07)', opacity: 0.7, blur: 50, top: '20%', left: '15%' },
    { shape: 'rounded', size: 100, color: 'rgba(10, 132, 255, 0.06)', opacity: 0.5, blur: 40, top: '70%', left: '75%' },
    { shape: 'circle', size: 90, color: 'rgba(255, 215, 0, 0.05)', opacity: 0.4, blur: 30, top: '25%', left: '80%' },
  ];

  return (
    <PromptContainer>
      {floatingElements.map((element, index) => (
        <FloatingElement 
          key={index}
          shape={element.shape}
          size={element.size}
          color={element.color}
          opacity={element.opacity}
          blur={element.blur}
          style={{ top: element.top, left: element.left }}
        />
      ))}
      
      <GlassCard>
        <GlowBackground />
        
        <HeaderContainer>
          <TitleBlock>
            <MainTitle>Find What to Cook — Fast</MainTitle>
            <Subtitle>No stress. Just tasty ideas.</Subtitle>
          </TitleBlock>
          
          <AppIconContainer>
            <AppIconImage 
              src={appicon} 
              alt="Chef Kats App Icon" 
            />
          </AppIconContainer>
        </HeaderContainer>
        
        <BenefitItem>
          <BenefitIcon>
            <img src={token} alt="Tokens" />
          </BenefitIcon>
          <BenefitText>
            <BenefitTitle>Get <span>360</span> tokens every week</BenefitTitle>
            <BenefitDescription>to make more recipes with zero guesswork</BenefitDescription>
          </BenefitText>
        </BenefitItem>
        
        <BenefitItem>
          <BenefitIcon>
            <span style={{ fontSize: '32px' }}>🍽️</span>
          </BenefitIcon>
          <BenefitText>
            <BenefitTitle>Make <span>3</span> meals at once</BenefitTitle>
            <BenefitDescription>instead of just one idea</BenefitDescription>
          </BenefitText>
        </BenefitItem>
        
        <BenefitItem>
          <BenefitIcon>
            <span style={{ fontSize: '32px' }}>✨</span>
          </BenefitIcon>
          <BenefitText>
            <BenefitTitle>Tell us what you like</BenefitTitle>
            <BenefitDescription>and we'll match recipes just for you</BenefitDescription>
          </BenefitText>
        </BenefitItem>
        
        <DownloadButton
           target="_blank"
          onClick={(e) => {
            e.preventDefault(); // чтобы не переходило мгновенно
            if (typeof window !== 'undefined' && window.gtag_report_conversion) {
              window.gtag_report_conversion('https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693');
            } else {
              // fallback — если функция не сработала
              window.location.href = 'https://apps.apple.com/us/app/chefkats-ai-snap-cook/id6739225693';
            }
          }}
        >
          <AppleIcon />
          Try Chef Kats — It's Free        </DownloadButton>
      </GlassCard>
    </PromptContainer>
  );
};

export default DownloadPrompt; 
 